import React, { useEffect, useState } from 'react'
import EditJobStyles from './EditFAQ.module.css'
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';



  // import this for redux read write
  import { useSelector, useDispatch } from 'react-redux'
  import { setNotifications } from '../../state/GlobalState'
  import { setNotificationCount } from '../../state/GlobalState'


const EditFAQ = () => {

    // get data from redux
    const name=useSelector((state)=>state.globalData.name);
    const count=useSelector((state)=>state.globalData.notificationCount);
    const dispatch =  useDispatch()


    const location = useLocation()
    const data = location.state
    console.log(data)

    const navigate = useNavigate()

    const inputRef = React.useRef();

    const [faqQuestion, setfaqQuestion] = useState('')
    const [faqAnswer, setfaqAnswer] = useState('')


    useEffect(() => {
        if (data) {
            setfaqQuestion(data.faqQuestion)
            setfaqAnswer(data.faqAnswer)
            
        }
    }, [data])

    const handleSubmit = async (event) => {
        event.preventDefault()
        try {
            const jobResponse = await axios.post(
                `${process.env.REACT_APP_STEELADMIN}/faqCategory/updateFaq/${data.faqId}`,
                { faqQuestion, faqAnswer,  },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            // console.log('Q&A Updated.')
            // console.log(jobResponse)

            
             // this is the snipte for the notification

       const dateTime=jobResponse.data.date;

       const [dateString,timeString]=dateTime.split("T");

       const date=new Date(dateString);

       const time=timeString.substr(0,8);


       const localDate=date.toLocaleDateString();

       dispatch(setNotifications({
           notification:{
             name:name,
             details:jobResponse.data.message,
             time:time,
             date:localDate
           }
         }))
         dispatch(setNotificationCount({
          count:count+1,
         }))
         
       //   uptill here 

            
        } catch (error) {
            console.error(error)
        }
        alert('Q&A Updated.')
            navigate('/faqpage')
    }

    return (
        <div className={EditJobStyles.jobMain}>
            <div className={EditJobStyles.jobContent}>
                <form action="" className={EditJobStyles.jobForm} onSubmit={handleSubmit}>
                  
                    <label className={EditJobStyles.jobFormLabel}>Question</label>
                    <textarea className={EditJobStyles.jobFormDesc} value={faqQuestion} name='faqQuestion' onChange={(event) => setfaqQuestion(event.target.value)} />
                    <label className={EditJobStyles.jobFormLabel}>Answer</label>
                    <textarea className={EditJobStyles.jobFormDesc} value={faqAnswer} name='faqAnswer' onChange={(event) => setfaqAnswer(event.target.value)} />
                 
                    <Button type='submit' className={EditJobStyles.postButton} variant='contained'>Edit Q&A</Button>
                </form>
            </div>
        </div>
    )
}

export default EditFAQ